var Map_Handler = {
	array_marker:[],
	map:undefined,
	latCenter: {lat: 47, lng: 2},
	zoom:6.2,
	zoom_hover:10,
	locations:[],
	locations_w_jobs : [],
	
	init:function(){
		$('.marker').each(function (el) {
			var location = $(this).data('location');
			if(!Map_Handler.locations.includes(location)){
				Map_Handler.locations.push(location);
			}
		});

		$('.offre').each(function(el){
			var location = $(this).data('location');
			$(this).attr('data-type', $(this).attr('data-type').replaceAll(' ', '-'));
			if(!Map_Handler.locations_w_jobs.includes(location)){
				Map_Handler.locations_w_jobs.push(location);
			}
		});

		$.each(Map_Handler.locations_w_jobs, function(i, val){
			if(!Map_Handler.locations.includes(val)){
				var geocoder = new google.maps.Geocoder();
				var offre = $('.offre[data-location="'+val+'"]');
				var location = offre.data('address')+', '+val+', France';
				geocoder.geocode({'address': location}, function(results, status) {
					if (status === 'OK') {
						offre.attr('data-lat', results[0].geometry.location.lat());
						offre.attr('data-lng', results[0].geometry.location.lng());
						$('.positions-markers').append('<div class="marker" data-lat="'+results[0].geometry.location.lat()+'" data-lng="'+results[0].geometry.location.lng()+'" data-location="'+offre.data('location')+'">');
					}
				});
				Map_Handler.locations.push(val);
			}
		});
		$.each(Map_Handler.locations, function(i, val){
			if(!Map_Handler.locations_w_jobs.includes(val)){
				$('.marker[data-location="'+val+'"]').remove();
			}else{
				$('.offre[data-location="'+val+'"]').attr('data-lat',$('.marker[data-location="'+val+'"]').attr('data-lat'));
				$('.offre[data-location="'+val+'"]').attr('data-lng',$('.marker[data-location="'+val+'"]').attr('data-lng'));
			}
		});
		console.log(Map_Handler.locations);
		console.log(Map_Handler.locations_w_jobs);
		setTimeout(function(){
			console.log("INIT MAP");
			document.querySelector(".listes-offres-container .offres").addEventListener("mouseleave", function(){
				var latlng = new google.maps.LatLng(Map_Handler.latCenter.lat, Map_Handler.latCenter.lng);
				Map_Handler.map.setZoom(Map_Handler.zoom);
				Map_Handler.map.panTo(latlng);
				
			});
			document.querySelectorAll(".listes-offres-container .offre").forEach(function(btn_offre){
				btn_offre.addEventListener("mouseenter", function(e){
					var latlng = new google.maps.LatLng(e.target.getAttribute("data-lat"), e.target.getAttribute("data-lng"))
					Map_Handler.map.setZoom(Map_Handler.zoom_hover);
					Map_Handler.map.panTo(latlng);
					
				})
			})

			document.querySelectorAll(".positions-markers .marker").forEach(function(marker){
				
				var _lat = marker.getAttribute("data-lat");
				var _lng = marker.getAttribute("data-lng");
				
				var _found = false;
				Map_Handler.array_marker.forEach(function(item){
					
					if(item.lat == _lat && item.lng == _lng) {
						_found = true;
						
					}
				})
				if(_found == false){					
					Map_Handler.array_marker.push({
						lat:marker.getAttribute("data-lat"), 
						lng:marker.getAttribute("data-lng"),
						location:marker.getAttribute("data-location")
					});	
				}	
			});
			

			Map_Handler.map = new google.maps.Map(document.getElementById('rejoindre-map'), {
				center: Map_Handler.latCenter,
				zoom: Map_Handler.zoom,
				disableDefaultUI: false
			});
			
			var icon = {
				path: "M18.8886 0H18.8029C8.43478 0 0 8.43197 0 18.7961C0 25.5898 3.09395 34.5558 9.19587 45.4455C13.7198 53.5187 18.3072 59.702 18.3531 59.7634C18.4808 59.935 18.6821 60.036 18.8953 60.036C18.9014 60.036 18.9076 60.036 18.9136 60.0357C19.1337 60.0297 19.3368 59.9171 19.4588 59.7337C19.504 59.6652 24.0587 52.7871 28.5519 44.3744C34.6166 33.0198 37.6917 24.4137 37.6917 18.7961C37.6913 8.43182 29.2564 0 18.8886 0ZM27.5677 19.2554C27.5677 24.0649 23.6551 27.9775 18.8456 27.9775C14.0362 27.9775 10.1235 24.0648 10.1235 19.2554C10.1235 14.4461 14.0362 10.5334 18.8456 10.5334C23.6551 10.5334 27.5677 14.4461 27.5677 19.2554Z",
				fillColor: '#FEBF3E',
				fillOpacity: 1,
				anchor: new google.maps.Point(16,60),
				strokeWeight: 0,
				scale: 1
			}
			Map_Handler.array_marker.forEach(function(item){
				console.log("CREATE MARKER");
				var _lat = parseFloat(item.lat);
				var _lng = parseFloat(item.lng);
				var _position = new google.maps.LatLng(_lat, _lng);
				var marker = new google.maps.Marker({
					position: _position,
					icon:icon,
					title: item.location
				});
				marker.setMap(Map_Handler.map);
				marker.addListener('click', function (marker){
					Filter_Offres.selected_location = this.getTitle();
					Filter_Offres.filter_offres();
					Map_Handler.map.setCenter(this.getPosition());
					Map_Handler.map.setZoom(Map_Handler.zoom_hover);
				});
			});
			
		}, 2000);
		$('.autour-de-moi').on('click', function () {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(function (position) {
					initialLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
					Map_Handler.map.setCenter(initialLocation);
					Map_Handler.map.setZoom(Map_Handler.zoom_hover);
				});
			}
		});

		$('.postulez-search-form').on('submit', function(ev){
			ev.preventDefault();
			Map_Handler.centerOnCity($('#city_search').val());
		});
	},
	centerOnCity: function (city){
		var geocoder = new google.maps.Geocoder();
		geocoder.geocode({'address': city}, function(results, status) {
			if (status === 'OK') {
				Map_Handler.map.setCenter(results[0].geometry.location);
				Map_Handler.map.setZoom(Map_Handler.zoom_hover);
			}
		});
	},

}

function initMapRejoindre(){
	Map_Handler.init();
}

$(window).on('load', function() {
	var theScript = document.createElement("script");
	theScript.setAttribute("type", "text/javascript");
	theScript.setAttribute("src", "https://maps.googleapis.com/maps/api/js?key=AIzaSyDq4MlxaeTWSBrRM8HuhLezApx9G3hsYrw&callback=initMapRejoindre&v=weekly");
	document.getElementsByTagName("head")[0].appendChild(theScript);
});